module.exports = __webpack_public_path__ + "static/media/speedometer.61984d1d.svg";